export class ValidationError extends Error {
  constructor(message: string = '') {
    super(message);
    this.name = 'ValidationError';
    this.message = message;
  }
}

export const isValidationError = (error: Error): boolean => error instanceof ValidationError;
